import React from 'react';
import { Router } from '@gatsbyjs/reach-router';
import InternalError from './components/InternalError';
import { ResultsDeparture, ResultsReturn, GuestInfo, Confirmation, Payment } from './pages';
import { NAVIGATION_PATHS } from './utils/constants';
import BrowseSummary from './pages/BrowseSummary';
import BrowseResultsDeparture from './pages/BrowseResultsDeparture';
import BrowseResultsReturn from './pages/BrowseResultsReturn';
import BookFlights from './pages/BookFlights';
import FlightsCancellation from './pages/FlightsCancellation';
import Manage from './pages/Manage';
import CancelConfirmation from './pages/CancelConfirmation';

const Routes = ({ urlPath = '' }) => (
  <Router className="route-content">
    <ResultsDeparture path={`${urlPath}${NAVIGATION_PATHS.resultsDeparture}/*`} />
    <ResultsReturn path={`${urlPath}${NAVIGATION_PATHS.resultsReturn}/*`} />
    <GuestInfo path={`${urlPath}${NAVIGATION_PATHS.reviewFlight}/*`} />
    <Payment path={`${urlPath}${NAVIGATION_PATHS.payment}/*`} />
    <Confirmation path={`${urlPath}${NAVIGATION_PATHS.confirmation}/*`} />
    <InternalError path={`${urlPath}${NAVIGATION_PATHS.error}/*`} />
    <BrowseSummary path={`${urlPath}${NAVIGATION_PATHS.browseSummary}/*`} />
    <BrowseResultsDeparture path={`${urlPath}${NAVIGATION_PATHS.browseDeparture}/*`} />
    <BrowseResultsReturn path={`${urlPath}${NAVIGATION_PATHS.browseReturn}/*`} />
    <BookFlights default path={`${urlPath}${NAVIGATION_PATHS.bookFlights}/*`} />
    <FlightsCancellation path={`${urlPath}${NAVIGATION_PATHS.flightsCancellation}/*`} />
    <Manage path={`${urlPath}${NAVIGATION_PATHS.manage}/*`} />
    <CancelConfirmation path={`${urlPath}${NAVIGATION_PATHS.cancelConfirmation}/*`} />
  </Router>
);

export default Routes;
